
import API from '@/api'

const actions = {
  getFlights({ commit, state }, { flightIndex, form }) {
    API.flights.getCollection(form)
      .then(({ data: { data: { results, searchId }, meta } }) => {
        if (state.flights[flightIndex].aviatickets.hasError) {
          commit('setServiceModuleErrors', {
            target: `flights.${flightIndex}.aviatickets`,
            status: false,
            errors: []
          })
        }

        commit('updateIsCollectionLoading', {
          flightIndex,
          status: false
        })

        if (meta.page === 1) {
          commit('updateServiceModuleIsLoading', {
            status: false,
            target: `flights.${flightIndex}.aviatickets`,
          })

          if (results.length === 0) {
            commit('setServiceModuleErrors', {
              target: `flights.${flightIndex}.aviatickets`,
              status: true,
              errors: ['По вашему запросу ничего не найдено, измените параметры поиска.']
            })
          }

          commit('setFlights', { results, searchId, flightIndex })
        } else {
          commit('updateFlights', { results, flightIndex })
        }

        commit('updatePagination', {
          flightIndex,
          meta
        })
      })
      .catch(({ data: { errors } }) => {
        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `flights.${flightIndex}.aviatickets`,
        })

        commit('setServiceModuleErrors', {
          target: `flights.${flightIndex}.aviatickets`,
          status: true,
          errors
        })
      })
  },
  getFlightTarrifs({ commit }, { aviaticketId, flightIndex, ...ids }) {
    API.flights.getFlightTarrifs(ids)
      .then(({ data: { data: { results } } }) => {
        if (results.length) {
          commit('setFlightService', {
            id: aviaticketId,
            flightIndex,
            service: 'tarrifs',
            results
          })
        } else {
          commit('setFlightServiceErrors', {
            id: aviaticketId,
            flightIndex,
            service: 'tarrifs',
            errors: ['Ошибка загрузки тарифов.']
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('setFlightServiceErrors', {
          id: aviaticketId,
          flightIndex,
          service: 'tarrifs',
          errors: ['Ошибка загрузки тарифов.']
        })
      })
  },
  getFlightRules({ commit }, { aviaticketId, flightIndex, ...ids }) {
    API.flights.getFlightRules(ids)
      .then(({ data: { data: { results } } }) => {
        if (results.length) {
          commit('setFlightService', {
            id: aviaticketId,
            flightIndex,
            service: 'rules',
            results
          })
        } else {
          commit('setFlightServiceErrors', {
            id: aviaticketId,
            flightIndex,
            service: 'rules',
            errors: ['Ошибка загрузки правил перелета.']
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('setFlightServiceErrors', {
          id: aviaticketId,
          flightIndex,
          service: 'rules',
          errors: ['Ошибка загрузки правил перелета.']
        })
      })
  },
  getFlightQuotasDates({ commit }, payload) {
    API.flights.getFlightQuotasDates(payload)
      .then(({ data: { data } }) => {
        commit('setFlightQuotasDates', data)
      })
      .catch(() => {})
  }
}

export default actions